module.exports = __webpack_public_path__ + "img/livu-logo-1.43df640b.png";